import { Box, Typography } from "@mui/material"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface StepSectionHeaderProps {
  title: string
  complete?: boolean
}

export const StepSectionHeader: FC<StepSectionHeaderProps> = ({ title, complete = false }) => (
  <Box className='mb-6 flex items-center'>
    <Typography variant='body1' className='font-bold leading-6 text-gray-700'>
      {title}
    </Typography>
    {complete && <CheckCircleFilledRounded className='ml-1 text-success-500' />}
  </Box>
)
